import _ from 'lodash';

import type { ErrorFieldType } from '@/types';

// Si une erreur concerne le premier panel
export const identificationHasErrors = (errors: ErrorFieldType[]) =>
  _.some(errors, ({ id }) =>
    _.includes(
      [
        'nom',
        'prenom',
        'civilite',
        'adresse',
        'dateNaissance',
        'departementNaissance',
        'villeNaissance',
        'paysNaissance',
        'telephone',
        'portable',
        'mail',
      ],
      id,
    ),
  );

// Si une erreur concerne le premier panel
export const commentaireHasErrors = (errors: ErrorFieldType[]) =>
  _.some(errors, ({ id }) => _.includes(['commentaire'], id));
